import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MenuBar = () => {
    const location = useLocation();

    // Navigation Items with Paths
    const navItems = [
        { 
            name: 'Home', 
            path: '/', 
            icon: <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path> 
        },
        { 
            name: 'Work', 
            path: '/work', 
            icon: <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path> 
        },
        { 
            name: 'Services', 
            path: '/service', 
            icon: <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path> 
        },
        { 
            name: 'Contact', 
            path: '/contact', 
            icon: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2-2z"></path> 
        },
        { 
            name: 'INSIGHTS', 
            path: '/caseStudies', 
            icon: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2-2z"></path> 
        }
    ];

    // Helper to check if link is active
    const isActive = (path) => location.pathname === path;

    return (
        <>
            {/* --- DESKTOP NAV (Top Bar) --- */}
            <nav className="hidden md:flex fixed top-0 left-0 right-0 z-50 px-8 py-6 items-center justify-between backdrop-blur-md bg-[#0f172a]/80 border-b border-white/5 transition-all duration-300">
                
                {/* Logo */}
                <Link to="/" className="text-2xl font-bold tracking-tighter text-white hover:opacity-80 transition-opacity">
                    TOP <span className="text-[#00F0FF]">ORION</span>
                </Link>

                {/* Links */}
                <div className="flex gap-8">
                    {navItems.map((item) => (
                        <Link 
                            key={item.name} 
                            to={item.path} 
                            className={`text-sm font-medium transition-all duration-300 uppercase tracking-widest hover:text-white ${
                                isActive(item.path) 
                                ? 'text-[#00F0FF] drop-shadow-[0_0_8px_rgba(0,240,255,0.5)]' 
                                : 'text-gray-400'
                            }`}
                        >
                            {item.name}
                        </Link>
                    ))}
                </div>

                {/* CTA Button */}
                <Link to="/startProject">
                    <button className="px-6 py-2 border border-[#00F0FF] text-[#00F0FF] hover:bg-[#00F0FF] hover:text-black transition-all duration-300 rounded-full font-bold text-sm shadow-[0_0_10px_rgba(0,240,255,0.2)] hover:shadow-[0_0_20px_rgba(0,240,255,0.6)]">
                        START PROJECT
                    </button>
                </Link>
            </nav>


            {/* --- MOBILE NAV (Bottom App Dock) --- */}
            <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#27272a]/90 backdrop-blur-lg border-t border-white/10 pb-safe shadow-2xl">
                <div className="flex justify-around items-center h-20">
                    {navItems.map((item) => (
                        <Link 
                            key={item.name} 
                            to={item.path} 
                            className="flex flex-col items-center gap-1 group w-full relative"
                        >
                            {/* Active Indicator Dot (Mobile Only) */}
                            {isActive(item.path) && (
                                <div className="absolute -top-3 w-8 h-1 bg-[#00F0FF] rounded-b-full shadow-[0_0_10px_#00F0FF]"></div>
                            )}

                            {/* Icon SVG */}
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                width="24" 
                                height="24" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="currentColor" 
                                strokeWidth="2" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                                className={`transition-all duration-300 ${
                                    isActive(item.path)
                                    ? 'text-[#00F0FF] drop-shadow-[0_0_5px_rgba(0,240,255,0.8)] -translate-y-1'
                                    : 'text-gray-400 group-hover:text-white'
                                }`}
                            >
                                {item.icon}
                            </svg>
                            
                            {/* Label */}
                            <span className={`text-[10px] font-medium transition-colors ${
                                isActive(item.path) ? 'text-white' : 'text-gray-500'
                            }`}>
                                {item.name}
                            </span>
                        </Link>
                    ))}
                </div>
            </nav>
        </>
    );
};

export default MenuBar;